import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// 🔹 Get Bots (with pagination, search, and filter by user)
export async function getBots(website_user, page_no = 0, search_key = "") {
  try {
    const fd = new FormData();
    fd.append("website_user", website_user);
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}supbot/get_bots`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getBots error:", error);
    return { status: false, type: "danger", success: "Failed to fetch bots" };
  }
}

// 🔹 Get Bot Report (total, active, inactive)
export async function getBotReport(website_user) {
  try {
    const fd = new FormData();
    fd.append("website_user", website_user);

    const response = await axios.post(`${apiBaseUrl}supbot/get_bot_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getBotReport error:", error);
    return { status: false, type: "danger", success: "Failed to load bot report" };
  }
}

// 🔹 Create or Update Bot
export async function createBot(
  website_id,
  website_chatbot_name,
  website_chatbot_status,
  website_chatbot_color,
  website_chatbot_avtar = null,
  website_chatbot_msg,
  website_chatbot_trianing_data = null
) {
  try {
    const fd = new FormData();

    fd.append("website_id", website_id);
    fd.append("website_chatbot_name", website_chatbot_name || "");
    fd.append("website_chatbot_status", website_chatbot_status || "active");
    fd.append("website_chatbot_color", website_chatbot_color || "#111827");
    fd.append("website_chatbot_msg", website_chatbot_msg || "");

    // 🖼️ Attach avatar file only if provided
    if (website_chatbot_avtar instanceof File) {
      fd.append("website_chatbot_avtar", website_chatbot_avtar);
    }

    // 📄 Attach training file only if provided
    if (website_chatbot_trianing_data instanceof File) {
      fd.append("website_chatbot_trianing_data", website_chatbot_trianing_data);
    }

    const response = await axios.post(`${apiBaseUrl}supbot/create_bot`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("❌ createBot error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to create or update bot. Please try again.",
    };
  }
}

// 🔹 Delete Bot (Disable chatbot and clear fields)
export async function deleteBot(website_id) {
  try {
    const fd = new FormData();
    fd.append("website_id", website_id);

    const response = await axios.post(`${apiBaseUrl}supbot/delete_bot`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteBot error:", error);
    return { status: false, type: "danger", success: "Bot delete request failed" };
  }
}
